import PartnerFields from '../components/PartnerFields';
import CommaInput from '../components/CommaInput';
import MessageModal from '../components/MessageModal';
import Range from '../components/range/Range';
import RangeReverse from '../components/range/RangeReverse';
import PieChart from '../components/charts/Pie';
import BarChart from '../components/charts/HorizontalBar';
import SearchResults from '../components/SearchResults';
import DatePicker from 'vue-bootstrap-datetimepicker';

import partnersMixin from '../vue/mixins/form/partners';
import sharesMixin from '../vue/mixins/form/shares';
import companyMixin from '../vue/mixins/form/company';
import datesMixin from '../vue/mixins/form/dates';
import directorsMixin from '../vue/mixins/form/directors';
import signingMixin from '../vue/mixins/form/signing';
import termsMixin from '../vue/mixins/form/terms';
import termDetailsMixin from '../vue/mixins/form/term-details';
import obligationsMixin from '../vue/mixins/form/obligations';
import {highlightMethod as hasInfoHighlighterMixin} from '../vue/mixins/has-info-highlighter';
import hasInfoBoxMixin from '../vue/mixins/has-info-box';
import ValidationMixin from '../vue/mixins/validation';
import dbOptionsMixin from '../vue/mixins/dp-options';


new Vue({
    el: '#vueApp',
    mixins: [
        partnersMixin,
        sharesMixin,
        companyMixin,
        datesMixin,
        directorsMixin,
        signingMixin,
        termsMixin,
        termDetailsMixin,
        obligationsMixin,
        hasInfoHighlighterMixin,
        hasInfoBoxMixin,
        ValidationMixin,
        dbOptionsMixin,
    ],
    components: {
        PartnerFields,
        CommaInput,
        MessageModal,
        PieChart,
        BarChart,
        DatePicker,
        Range,
        RangeReverse,
        SearchResults,
    },
    data() {
        return {
            currentStep: 1,
            totalSteps: 9,
            passedSteps: {
                1: false,
                2: false,
                3: false,
                4: false,
                5: false,
                6: false,
                7: false,
                8: false,
                9: false,
            },
            isHoveringUpsell: false,
            submitting: false,
            filledFromDraft: false,
            formCompleted,
            authorized: Laravel.authorized,
        };
    },
    computed: {
        formFillPercent() {
            return Math.round((this.currentStep * 100) / this.totalSteps);
        },
        showSidebar() {
            return ![8, 9].includes(this.currentStep);
        },
    },
    mounted() {
        if (draftForm && !this.formCompleted) {
            this.$refs.loadDraftFormModal.open();
        } else {
            this.$nextTick(() => {
                this.fillFormDraftData();
            });
        }

        $('#contract-form').removeClass('d-none');
        $('.main-loader').remove();
        this.adjustInfoBox();
    },
    methods: {
        indexOf(assocId, dataItem) {
            switch (dataItem) {
                case 'partners': {
                    return this.partnerIds.indexOf(assocId);
                }
                case 'directors': {
                    return this.directorIds.indexOf(assocId);
                }
                default:
                    return -1;
            }
        },
        switchToNextStep() {
            if (this.currentStep === 1) {
                this.checkDirectorsDetails();
            }

            if (this.currentStep <= this.totalSteps) {
                this.switchToStep(this.currentStep + 1);
            }
        },
        switchToPreviousStep() {
            if (this.currentStep > 1) {
                this.switchToStep(this.currentStep - 1, false);
            }
        },
        switchToStep(nextStep, validateStep = true) {
            let form = '';
            let data = {};

            switch (this.currentStep) {
                case 1: {
                    form = 'partners';
                    data = {partners: this.partners};
                    break;
                }
                case 2: {
                    form = 'shares';
                    data = {
                        shares: this.partnerShares,
                        call_assembly_percent: this.company.call_assembly_percent,
                    };
                    break;
                }
                case 3: {
                    form = 'company';
                    data = {company: this.company};
                    break;
                }
                case 4: {
                    form = 'dates';
                    data = {dates: this.dates};
                    break;
                }
                case 5: {
                    form = 'directors';
                    data = {directors: this.directors};
                    break;
                }
                case 6: {
                    form = 'signing';
                    if (validateStep) {
                        this.checkForSigningConflicts();
                        if (this.signingConflicts.length || this.missingSigningDirector) {
                            return;
                        }
                    }

                    data = {signing: this.signing};
                    break;
                }
                case 7: {
                    form = 'terms';
                    data = {terms: this.selectedTerms};
                    break;
                }
                case 8: {
                    form = 'term-details';
                    data = {
                        terms: this.selectedTerms,
                        partner_max_share: this.partnerMaxShare,
                        details: this.termDetails
                    };
                    break;
                }
                case 9: {
                    form = 'term-obligations';
                    data = {
                        terms: this.selectedTerms,
                        shares: this.partnerShares,
                        partner_ids: this.partnerIds,
                        obligations: this.obligations
                    };
                    break;
                }
                default:
                    break;
            }

            if (validateStep) {
                this.submitFormStep(form, data, () => {
                    if (nextStep <= this.totalSteps) {
                        this.moveToStep(nextStep);
                        this.$nextTick(() => {
                            this.saveDraftForm();
                        });
                    } else {
                        this.saveDraftForm(true);
                        this.formCompleted = true;
                    }
                });
            } else {
                this.moveToStep(nextStep);
                this.saveDraftForm();
            }
        },
        moveToStep(nextStep) {
            this.passedSteps[this.currentStep] = true;
            this.currentStep = nextStep;
            this.hideInfo();
            this.adjustInfoBox();
        },
        checkDirectorsDetails() {
            for (let director in this.directors) {
                console.log(Object.keys(this.partners).includes(director));

                if(Object.keys(this.partners).includes(director)){

                    const partner = this.partners[director];

                    this.$set(this.directors, director, {
                        id: director,
                        gender: partner.gender,
                        title_prefix: partner.title_prefix,
                        title_postfix: partner.title_postfix,
                        first_name: partner.first_name,
                        last_name: partner.last_name,
                        birthdate: partner.birthdate,
                        street: partner.street,
                        street_nr: partner.street_nr,
                        zip_code: partner.zip_code,
                        city: partner.city,
                        country: partner.country,
                    });
                }
            }
        },
        submitFormStep(form, data, callback) {
            this.submitting = true;
            this.clearValidationErrors();

            ajax('POST', `/validate/${form}`, data)
                .then((response) => {
                    callback(response.data);
                })
                .catch((e) => {
                    this.passedSteps[this.currentStep] = false;
                    this.handleErrors(e.response);
                })
                .then(() => {
                    this.submitting = false;
                });
        },
        adjustInfoBox() {
            switch (this.currentStep) {
                case 6: {
                    this.permanentInfoText = __(`explanations.step_signing_rights_explanation`);
                    break;
                }
                default:
                    this.permanentInfoText = null;
                    break;
            }

            let windowHeight = $(window).height(),
                spaces = 16 + 345 + 16,
                mainCardHeight = $('#main_card').outerHeight() - 32, //32 is padding
                maxHeight;

            if (this.currentStep === 4) {
                let headerHeight = $('#card_header').outerHeight(true),
                    secondaryCardHeight = $('#secondary_card').outerHeight(true);

                maxHeight = mainCardHeight + headerHeight + secondaryCardHeight;
            } else if (this.currentStep === 7) {
                maxHeight = windowHeight - spaces - 215;
            } else if (mainCardHeight && mainCardHeight < windowHeight - spaces) {
                maxHeight = mainCardHeight;
            } else {
                maxHeight = windowHeight - spaces;
            }

            $('#info_text').css('max-height', maxHeight + 'px');
        },
        addCommas($event) {
            let value = $event.target.value,
                sanitizedCommasValue = value.replace(/(\D)/g, '');

            $event.target.value = Number(sanitizedCommasValue).toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
        },
        handleErrors(error) {
            switch (error.status) {
                case 422: {
                    if ($(document).height() > 2000) {
                        this.$refs.validationErrorModal.open();
                    }
                    this.setValidationErrors(error.data.errors);
                    break;
                }
                case 419: {
                    this.$refs.tokenExpiredModal.open(() => {
                        window.location.reload();
                    });
                    break;
                }
                default: {
                    this.$refs.errorModal.open();
                    break;
                }
            }
        },
        saveDraftForm(completed = false) {
            const data = {
                partners: this.partners,
                directors: this.directors,
                company: this.company,
                dates: this.dates,
                signing: this.signing,
                selectedTerms: this.selectedTerms,
                termDetails: this.termDetails,
                selectedPlan: this.selectedPlan,
                obligations: this.obligations,
                currentStep: this.currentStep,
                passedSteps: this.passedSteps,
            };

            ajax('POST', 'form/draft', {
                form_data: data,
                current_step: this.currentStep,
                plan: this.selectedPlan.name,
                completed,
            }).then((response) => {
                //
            }).catch((e) => {
                this.handleErrors(e.response);
            });
            // .then(() => {
            //     this.submitting = false;
            // });
        },
        exists(item) {
            return typeof item !== 'undefined';
        },
        backToFillingForm() {
            this.saveDraftForm();
            this.formCompleted = false;
        },
        fillFormDraftData() {
            this.filledFromDraft = true;

            if (draftForm && Array.isArray(draftForm.directors) && !draftForm.directors.length) {
                draftForm.directors = {};
                draftForm.signing = {};
            }
            Object.assign(this.$data, draftForm);

            setTimeout(() => {
                this.filledFromDraft = false;
            }, 100);

            this.$nextTick(() => {
                this.setSelectedTerms();
                this.adjustInfoBox();
            });
        },
    },
});
